import { HasValueParamUtils, ParamUtils } from '.'
import TypeValueUtils from '@/core/utils/TypeValueUtils'

export default class SearchUrlParamBuilder {
	constructor(paramsSearch) {
		const { urlPath, filters, pagingAndSorting, configParamsFilters } = this._paramsSearch(paramsSearch)
		this.urlPath = urlPath
		this.filters = filters
		this.pagingAndSorting = this._paramPagingAndSorting(pagingAndSorting)
		this.configParamsFilters = configParamsFilters
	}

	montaUrl(urlFilters, urlPagingAndSorting) {
		return `${this.urlPath}${this.temParametros(urlFilters, urlPagingAndSorting)}${urlFilters}${
			this.temFiltros(urlFilters) && this.temPaginacao(urlPagingAndSorting) ? '&' : ''
		}${urlPagingAndSorting}`
	}

	temParametros(urlFilter, urlPagingAndSort) {
		if (this.temFiltros(urlFilter) || urlPagingAndSort) return '?'
		return ''
	}

	temPaginacao(urlPagingAndSorging) {
		return !!urlPagingAndSorging
	}

	temFiltros(urlFilter) {
		return !!urlFilter
	}

	build() {
		this._validateFilters()

		const urlFilters = new ParamUtils(this.configParamsFilters).ObjectToParams(this.filters)
		const urlPagingAndSorting = new ParamUtils().ObjectToParams(this.pagingAndSorting)

		return this.montaUrl(urlFilters, urlPagingAndSorting)
	}

	buildFiltroPadraoEAvancado() {
		this._validateFilters()

		const urlFilters = this._buildFilters(this.filters)
		const urlPagingAndSorting = new ParamUtils().ObjectToParams(this.pagingAndSorting)

		return this.montaUrl(urlFilters, urlPagingAndSorting)
	}

	_buildFilters(filters) {
		const param = []

		for (const [key] of Object.entries(filters)) {
			if (filters[key].value) {
				param.push(`${key}=${this._normalizeFilter(filters[key].value)}`)
			}
		}
		return param.join('&')
	}

	_normalizeFilter(value) {
		if (!value || !TypeValueUtils.isString(value)) return value
		return value.trim()
	}

	_paramsSearch(paramsSearch) {
		return Object.assign(
			{
				urlPath: '',
				filters: {},
				pagingAndSorting: {},
				configParamsFilters: {},
			},
			paramsSearch,
		)
	}

	_paramPagingAndSorting({ rowsPerPage, page, sortBy, sortDesc }) {
		return Object.assign(
			{
				rowsPerPage: rowsPerPage,
				page: page,
				sortBy: [],
				direction: [],
			},
			this._paramSortByAndDirection(sortBy, sortDesc),
		)
	}

	_paramSortByAndDirection(sortBy, sortDesc) {
		const hasValue = new HasValueParamUtils()
		const hasSortBy = hasValue.hasValueArrayParam(sortBy)
		const hasSortDesc = hasValue.hasValueArrayParam(sortDesc)

		if (hasSortBy && hasSortDesc) {
			return {
				sortBy: sortBy[0],
				direction: sortDesc[0] ? 'DESC' : 'ASC',
			}
		}

		return {}
	}

	_validateFilters() {
		const pagingAndSortingKeys = ['rowsPerPage', 'page', 'sortBy', 'direction']

		for (const key of pagingAndSortingKeys) {
			if (Object.prototype.hasOwnProperty.call(this.filters, key)) {
				throw new TypeError(`O atributo "${key}" é utilizado como parâmetro da paginação.`)
			}
		}
	}

	static montarUrl(urlPath, filters = {}, pagingAndSorting = {}, isAdvancedSearch = false) {
		const urlBuilder = new SearchUrlParamBuilder({
			urlPath: urlPath,
			filters: filters,
			pagingAndSorting: pagingAndSorting,
		})

		return isAdvancedSearch ? urlBuilder.buildFiltroPadraoEAvancado() : urlBuilder.build()
	}
}
